import { createSlice } from '@reduxjs/toolkit';

import { appRecord } from "../utils/appRecord";

let pageCurrent = appRecord && !isNaN(parseInt(appRecord.pagination.currentPage, 10)) ?
  parseInt(appRecord.pagination.currentPage, 10) : 1;

const initialState = {
  currentPage: pageCurrent,
};

export const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
  },
});

export const { setCurrentPage } = paginationSlice.actions;

export default paginationSlice.reducer;
